import { Heading } from '../typography/Heading';
import { Text } from '../typography/Text';
import { Marquee } from '../ui/Marquee';
import { Icon } from '../ui/Icon';

export default function OurNetwork() {
    const countries = [
        'ETHIOPIA', 'DJIBOUTI', 'KENYA', 'UGANDA',
        'TANZANIA', 'PORTUGAL', 'ITALY', 'FRANCE',
        'INDIA', 'CHINA', 'USA', 'UK', 'UAE', 'SINGAPORE'
    ];

    return (
        <section className="py-24 bg-gray-900 overflow-hidden relative">
            {/* Background Decorations */}
            <div className="absolute top-0 left-0 w-64 h-64 bg-orange-500/10 rounded-full blur-[100px] pointer-events-none" />
            <div className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/10 rounded-full blur-[100px] pointer-events-none" />

            <div className="max-w-7xl mx-auto px-6 mb-16 relative z-10">
                <div className="text-center max-w-3xl mx-auto">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full border border-orange-500/30 bg-orange-500/10 mb-6">
                        <span className="w-2 h-2 rounded-full bg-orange-500 animate-pulse" />
                        <span className="text-xs font-semibold text-orange-400 tracking-wider">GLOBAL PRESENCE</span>
                    </div>
                    <Heading level={2} className="text-white text-4xl md:text-5xl lg:text-6xl mb-6">
                        Connecting Markets <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600">Worldwide</span>
                    </Heading>
                    <Text color="#9CA3AF" className="text-lg">
                        We have established strong trade routes and partnerships across major global hubs, ensuring your goods reach their destination safely and on time.
                    </Text>
                </div>
            </div>

            {/* Marquee Section */}
            <div className="relative py-8 border-y border-gray-800 bg-gray-900/50 backdrop-blur-sm">
                <Marquee speed={30} direction="left" className="py-4">
                    {countries.map((country) => (
                        <div key={country} className="flex items-center gap-3 opacity-50 hover:opacity-100 transition-opacity cursor-default">
                            <Icon name="globe" className="text-orange-500 w-5 h-5" />
                            <span className="text-4xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-b from-gray-700 to-gray-800 stroke-text hover:from-white hover:to-gray-400 transition-all duration-300">
                                {country}
                            </span>
                        </div>
                    ))}
                </Marquee>
            </div>

            {/* Supply Route Visual */}
            <div className="mt-20 max-w-7xl mx-auto px-6 text-center">
                <div className="inline-flex flex-col md:flex-row items-center gap-6 md:gap-12 px-8 py-6 rounded-3xl bg-gray-800/50 border border-gray-700 backdrop-blur-md">
                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl bg-blue-500/20 flex items-center justify-center text-blue-400">
                            <Icon name="package" className="w-6 h-6" />
                        </div>
                        <div className="text-left">
                            <div className="text-sm text-gray-400">Shipment Modes</div>
                            <div className="font-bold text-white">Sea, Air & Land</div>
                        </div>
                    </div>

                    <div className="hidden md:block w-px h-12 bg-gray-700" />

                    <div className="flex items-center gap-3">
                        <div className="w-12 h-12 rounded-xl bg-green-500/20 flex items-center justify-center text-green-400">
                            <Icon name="check-circle" className="w-6 h-6" />
                        </div>
                        <div className="text-left">
                            <div className="text-sm text-gray-400">Customs Clearance</div>
                            <div className="font-bold text-white">Full Support</div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
